import { IApplicationState } from 'shared/types/redux';

export const getCoworkingAmenities = ({ coworking }: IApplicationState) => coworking?.amenities || [];
